import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import EditableInput from '../../components/EditableInput';
import EditableSelect from './../../components/EditableSelect';
import UneditableInput from '../../components/UneditableInput';
import AdditionalInformation from '../../components/AdditionalInformation';
import ConfirmationModal from './../../components/ConfirmationModal';

import { getUsers, updateUser } from '../../services/user';
import { getChannels } from '../../services/channel';
import { deleteUser } from '../../services/user';
import { showAlert } from '../../store/ducks/alert';

import { Button, Switch, FormControlLabel, CircularProgress } from '@material-ui/core';
import { Save } from '@material-ui/icons';

const UsersInformation = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [user, setUser] = useState({});
  const [userChannels, setUserChannels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModalDeleteUser, setModalOpenDeleteUser] = useState(false);

  useEffect(() => {
    displayUser();
  }, []);

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updateUser(user.id, user);
      dispatch(showAlert('success', 'User has been updated! 🔥'));
    } catch (error) {
      console.log(error);
    }
  };

  const displayUser = async () => {
    const userId = props.match.params.id;
    try {
      setIsLoading(true);
      const { data } = await getUsers(0, { searchItem: 'id', search: userId });
      const channels = await getChannels(0, { searchItem: 'userId', search: userId });
      setUser(data.rows[0]);
      setUserChannels(channels.data.rows);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the user. 😔'));
      console.log(error);
    }
  };

  const turnOffUser = async () => {
    try {
      await deleteUser(user.uid);
      dispatch(showAlert('success', 'User successfully deleted! 😞'));
      history.push('/users');
    } catch (error) {
      dispatch(showAlert('error', error.message));
    } finally {
      setModalOpenDeleteUser(false);
    }
  };

  const editable = ['username', 'email', 'replyEmail', 'countryCode', 'timezoneAbbr'];

  const select = ['isAdmin', 'isBetaTester', 'isWriter', 'isEmailConfirmed', 'notify'];

  const uneditable = ['id', 'createdAt', 'updatedAt'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>{user.username}</h1>
        <div>
          <Button className="modal-btn" variant="contained" color="secondary" onClick={() => setModalOpenDeleteUser(true)}>
            Delete User
          </Button>
          <FormControlLabel
            control={
              <Switch
                className="enabled-switch"
                checked={user.isEnabled}
                onChange={e => setUser({ ...user, [e.target.name]: e.target.checked })}
                name="isEnabled"
                color="primary"
              />
            }
            label="Enabled"
            labelPlacement="start"
          />
        </div>
        {openModalDeleteUser && (
          <ConfirmationModal
            title={`Are you sure you want to delete user ${user.username}?`}
            onClose={() => setModalOpenDeleteUser(false)}
            onAction={() => turnOffUser()}
          />
        )}
      </div>
      <section className="update-section">
        <h3>Edit User</h3>
        <form onSubmit={handleUpdate} className="update-form">
          <div className="form-fields">
            <EditableInput data={user} setData={setUser} labels={editable} />
            <EditableSelect data={user} setData={setUser} labels={select} />
            <EditableSelect data={user} setData={setUser} labels={['deletedAt']} isDeletedAt />
            <UneditableInput data={user} labels={uneditable} />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update User
          </Button>
        </form>
      </section>
      <section className="additional-section">
        <h3>{user.username}'s Channels</h3>
        <AdditionalInformation useUid={true} data={userChannels} dataKey="name" path="channels" />
      </section>
    </>
  );
};

export default UsersInformation;
